import { cards } from '@/mocks/home';

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-3xl font-heading text-foreground-900 mb-2">
            精选推荐
          </h2>
          <p className="text-sm text-foreground-600">编辑精选的每日大赛最新内容，不容错过</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cards.map((card) => (
            <a
              key={card.id}
              href="#media"
              className="group block rounded-xl overflow-hidden bg-background-100 hover:bg-background-200/50 transition-colors cursor-pointer"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full text-[11px] font-medium bg-primary-500 text-white whitespace-nowrap">
                    {card.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors">
                  {card.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 line-clamp-2 leading-relaxed">
                  {card.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}